import { render, staticRenderFns } from "./CheckboxGridPicker.vue?vue&type=template&id=61635acd"
import script from "./CheckboxGridPicker.vue?vue&type=script&lang=js"
export * from "./CheckboxGridPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports